import React, { useEffect, useState } from 'react';
import MultiSelectControl from '../Fields/MultiSelectControl';
import { SelectListOption } from '../Fields/Types';
import { IToggleColumnProps } from './Interfaces';

const ToggleColumn: React.FC<IToggleColumnProps> = ({ colInfos, colUserSettings, onChangeToggleColumn }) => {
    const [colOptions, setColOptions] = useState<SelectListOption[]>([]);
    const [colValues, setColValues] = useState<string[]>([]);

    function onChange(val: string[]) {
        onChangeToggleColumn(val);
    }

    useEffect(() => {
        let colOpt: SelectListOption[] = [];

        colInfos.forEach((colInfo) => {
            if ((colInfo.dataProp || colInfo.title) && colInfo.visible !== false) {
                colOpt.push({ value: colInfo.dataProp ?? colInfo.title ?? '', label: colInfo.title ?? colInfo.dataProp ?? '-' })
            }
        });

        setColOptions(colOpt);
    }, [colInfos])

    useEffect(() => {
        setColValues(colUserSettings.filter(x => x.visible === true).map(x => x.dataProp))
    }, [colUserSettings])

    return (
        <div className='toggle-col'>
            <MultiSelectControl
                name={'toggle_col_' + Math.random()}
                width={200}
                value={colValues}
                validationResults={[]}
                onChange={onChange}
                options={colOptions}
            />
        </div>
    );
}
export default ToggleColumn;